import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useFlexFlagIsOn } from '@indeed/flex-feature-flags'

import { Button } from 'syft-acp-atoms/Button'
import { withTrackingTriggerHoc } from 'syft-acp-util/withTrackingTriggerHoc'
import { saveAgencyBookings } from 'syft-acp-core/actions/agency-bookings'
import { trackingEvents } from '../../tracking'
import { ClockEditReasonModal } from '../ClockEditReasonModal/ClockEditReasonModal'
import { getAgencyClockEditBookings } from '../ClockEditReasonModal/clockEditReason'

const ListingSaveAgencyBookingsButton = ({
  label,
  disabled,
  entityMap,
  clockTimeChanges,
  actions,
  shiftID,
  triggerEvent,
  timeZone,
}) => {
  const [clockEditBookings, setClockEditBookings] = useState([])
  const clockEditReasonsFlag = useFlexFlagIsOn('acp_clock_edit_reasons')

  const performSave = (reasons = {}) => {
    triggerEvent(trackingEvents.LISTING_INFO.AGENCY_BOOKING_SUBSECTION.SAVED, { shiftID })
    const entityMapWithBreakDuration = entityMap[shiftID].agency_shift_bookings.map(
      ({ break: { duration }, ...rest }) => ({
        break_duration: duration,
        ...rest,
        ...(reasons[String(rest.id)] ? { clock_edit_reason: reasons[String(rest.id)] } : {}),
      }),
    )

    actions.saveAgencyBookings(
      {
        entries: entityMapWithBreakDuration,
      },
      shiftID,
    )
  }

  const onClick = () => {
    const changedClockBookings = getAgencyClockEditBookings(clockTimeChanges, entityMap, shiftID, timeZone)

    if (clockEditReasonsFlag && changedClockBookings.length) {
      setClockEditBookings(changedClockBookings)

      return
    }

    performSave()
  }

  const submitClockEditReasons = reasons => {
    setClockEditBookings([])
    performSave(reasons)
  }

  return (
    <>
      <Button kind="success" onClick={onClick} disabled={disabled}>
        {label}
      </Button>
      <ClockEditReasonModal
        bookings={clockEditBookings}
        isShown={clockEditBookings.length > 0}
        onClose={() => setClockEditBookings([])}
        onSubmit={submitClockEditReasons}
      />
    </>
  )
}

ListingSaveAgencyBookingsButton.propTypes = {
  actions: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  triggerEvent: PropTypes.func.isRequired,
  entityMap: PropTypes.object.isRequired,
  clockTimeChanges: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  shiftID: PropTypes.number.isRequired,
  timeZone: PropTypes.string,
}

const mapStateToProps = state => {
  const {
    entityMap,
    clockTimeChanges = {},
    isSavingData,
    hasChanges = false,
  } = state.listingAgencyShiftBookings

  const disabled = isSavingData || !hasChanges

  return {
    disabled,
    entityMap,
    clockTimeChanges,
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ saveAgencyBookings }, dispatch),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTrackingTriggerHoc(ListingSaveAgencyBookingsButton))
